import { createContext } from "react";

export interface IAppContext {
  toggleThemeMode: () => void;
  currentTheme: "light" | "dark";
  mintRate: number;
}

export const AppContext = createContext<IAppContext>({} as IAppContext);
